import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Sun } from 'lucide-react';
import { API } from '../utils/helpers';
import MarkdownRenderer from './MarkdownRenderer';

const DailyCardWidget = () => {
  const [dailyCard, setDailyCard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/daily-card`, { credentials: 'include' })
      .then(res => res.json())
      .then(setDailyCard)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="glass-card p-6 mb-8 border border-gold-300/10">
      <div className="flex items-center gap-2 mb-4">
        <Sun className="w-5 h-5 text-gold-300 animate-pulse" />
        <span className="text-sm text-[var(--text-muted)]">Cargando carta del dia...</span>
      </div>
      <div className="flex gap-6">
        <div className="w-20 sm:w-24 aspect-[2/3] rounded-lg bg-white/5 animate-pulse" />
        <div className="flex-1 space-y-3">
          <div className="h-3 bg-white/5 rounded animate-pulse w-3/4" />
          <div className="h-3 bg-white/5 rounded animate-pulse w-full" />
          <div className="h-3 bg-white/5 rounded animate-pulse w-2/3" />
        </div>
      </div>
    </div>
  );
  if (!dailyCard) return null;

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      className="glass-card p-6 mb-8 border border-gold-300/10"
      data-testid="daily-card-widget"
    >
      <h2 className="text-lg font-bold gold-text mb-4 flex items-center gap-2">
        <Sun className="w-5 h-5" /> Carta del Dia
      </h2>
      <div className="flex gap-6 items-start">
        <div className="flex-shrink-0">
          <div className={`w-20 sm:w-24 aspect-[2/3] rounded-lg overflow-hidden border border-gold-300/10 shadow-lg shadow-purple-500/10 ${dailyCard.card.reversed ? 'rotate-180' : ''}`}>
            <img src={dailyCard.card.image} alt={dailyCard.card.name_es} className="w-full h-full object-cover" />
          </div>
          <p className="text-center text-xs text-purple-300 mt-2 font-medium">{dailyCard.card.name_es}</p>
          {dailyCard.card.reversed && <p className="text-center text-xs text-red-400">Invertida</p>}
        </div>
        <div className="flex-1 min-w-0">
          <MarkdownRenderer content={dailyCard.message} className="text-[var(--text-secondary)] text-sm" data-testid="daily-card-message" />
        </div>
      </div>
    </motion.div>
  );
};

export default DailyCardWidget;
